export const PerPageViewerActionTypes = {
  GET_PER_PAGE_VIEWER: undefined,
  SET_PER_PAGE_VIEWER: undefined,
};
